import { Modal } from "@legal-500/legal500-design-system";
import type { DashboardPreview as DashboardPreviewData } from "@/api/dataProducts.service";
import styles from "./DataProducts.module.css";

type DashboardPreviewProps = {
  preview: DashboardPreviewData;
  title: string;
  onClose: () => void;
};

export function DashboardPreview({ preview, title, onClose }: DashboardPreviewProps) {
  const frameTitle = `Preview of ${title}`;

  if (preview.kind === "omni") {
    return (
      <Modal isOpen onClose={onClose} title={frameTitle} size="large" blurBackground>
        <div className={styles.previewBody}>
          <a
            className={styles.previewUrl}
            href={preview.url}
            target="_blank"
            rel="noopener noreferrer"
          >
            {preview.url}
          </a>
          <iframe className={styles.previewFrame} title={frameTitle} src={preview.url} />
        </div>
      </Modal>
    );
  }

  return (
    <section className={styles.previewInline} aria-label={frameTitle}>
      <a className={styles.previewUrl} href={preview.url} target="_blank" rel="noopener noreferrer">
        {preview.url}
      </a>
      <iframe className={styles.previewFrame} title={frameTitle} src={preview.url} />
    </section>
  );
}
